module.exports = __webpack_public_path__ + "img/vt-switch-moon.e689bd27.svg";